import { useCallback } from 'react';
import { useRequirementConditionsState } from '../requirement/useRequirementConditionsState';
import { useCurrentConditionIndex } from './useCurrentConditionIndex';
import { EditableCondition } from '../../types';

export const useConditionState = () => {
  const { conditions, setConditions } = useRequirementConditionsState();
  const index = useCurrentConditionIndex();
  const condition = conditions[index ?? 0];
  const setCondition = useCallback(
    (setterFn: (newCondition: EditableCondition) => EditableCondition) =>
      setConditions((currentConditions) =>
        currentConditions.map((currentCondition, i) =>
          i === index ? setterFn(currentCondition) : currentCondition,
        ),
      ),
    [setConditions, index],
  );
  return { condition, setCondition };
};
